import React from 'react';
import PropTypes from 'prop-types';
import getSymbolFromCurrency from 'currency-symbol-map';

const CurrencyToSymbol = (props) => {
  const { currency, hideUnResolvedCurrency } = props;
  switch (currency.toUpperCase()) {
    case 'BTC':
      return (<i className="icon-bitcoin" />);
    case 'ETH':
      return (<i className="icon-ethereum" />);
    default:
      if (hideUnResolvedCurrency) {
        return (<span>{getSymbolFromCurrency(currency)}</span>);
      }
      return (<span>{getSymbolFromCurrency(currency) || currency}</span>);
  }
};

CurrencyToSymbol.defaultProps = {
  currency: 'USD',
  hideUnResolvedCurrency: false,
};
CurrencyToSymbol.propTypes = {
  currency: PropTypes.string,
  hideUnResolvedCurrency: PropTypes.bool,
};
export default CurrencyToSymbol;
